import * as React from 'react';
import { BehaviorSubject } from 'rxjs';
import { useAuth } from 'src/modules/Auth/hooks/useAuth';
import { useIsSessionExpired } from 'src/modules/Auth/AuthExpiration/useIsSessionExpired';

interface IAuthModalState {
  isModalOpen: boolean;
  refresh: boolean;
}
export const authModalState = new BehaviorSubject<IAuthModalState>({
  isModalOpen: false,
  refresh: false
});
interface IActions {
  refreshSession: () => void
  logout: () => void
}

export const useAuthModal = (): [IAuthModalState, IActions] => {
  const [, actions] = useAuth();
  const [state, setState] = React.useState<IAuthModalState>(authModalState.getValue());
  React.useEffect(() => {
    authModalState.subscribe((newState) => setState(newState));
  }, [])
  const isSessionExpired = useIsSessionExpired()
  React.useEffect(() => {
    authModalState.next({ ...state, ...{ isModalOpen: isSessionExpired } })
  }, [isSessionExpired])
  const refreshSession = () => {
    actions.refreshSession()
    authModalState.next({ ...state, ...{ isModalOpen: false } })
    if (state.refresh) {
      window.location.reload();
    }
  }
  const logout = () => {
    actions.logout()
    authModalState.next({ ...state, ...{ isModalOpen: false } })
  }
  return [
    state,
    {
      refreshSession,
      logout
    }
  ]
}